import { render, staticRenderFns } from "./DataTransfer.vue?vue&type=template&id=5553208a&scoped=true"
import script from "./DataTransfer.vue?vue&type=script&lang=js"
export * from "./DataTransfer.vue?vue&type=script&lang=js"
import style0 from "./DataTransfer.vue?vue&type=style&index=0&id=5553208a&prod&lang=scss&scoped=true"
import style1 from "./DataTransfer.vue?vue&type=style&index=1&id=5553208a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5553208a",
  null
  
)

export default component.exports